import { useMemo } from "react";
import { useUserCircle } from "@platform/hooks/useUserCircle";
import { makeTimeslotFromId } from "@platform/features/timeslots/utils/makeTimeslotFromId";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";
import { useProgram } from "./useProgram";

export const useCircleTimeslot = () => {
  const circle = useUserCircle();

  const { program } = useProgram();

  const userTimezoneOption = useUserTimezoneOption();

  const startTimeslot = useMemo(() => {
    if (
      !circle?.start_time_slot ||
      !userTimezoneOption ||
      !program?.scheduled_engagement_start_date
    )
      return null;

    if (typeof circle?.start_time_slot !== "number") return null;

    return makeTimeslotFromId(
      circle?.start_time_slot,
      program?.scheduled_engagement_start_date,
      userTimezoneOption
    );
  }, [circle?.start_time_slot, userTimezoneOption]);

  const endTimeslot = useMemo(() => {
    if (!circle?.end_time_slot || !userTimezoneOption) return null;

    if (typeof circle?.end_time_slot !== "number") return null;

    return makeTimeslotFromId(
      circle?.end_time_slot,
      program?.scheduled_engagement_start_date,
      userTimezoneOption
    );
  }, [circle?.end_time_slot, userTimezoneOption]);

  return { startTimeslot, endTimeslot };
};

export default useCircleTimeslot;
